"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decipher = exports.cipher = void 0;
const cipher = (salt) => {
    const textToChars = (text) => text.charCodeAt(0);
    const byteHex = (n) => ('0' + Number(n).toString(16)).substr(-2);
    const applySaltToChar = (code) => salt.split('').map(textToChars).reduce((a, b) => a ^ b, code);
    return (text) => text.split('')
        .map(textToChars)
        .map(applySaltToChar)
        .map(byteHex)
        .join('');
};
exports.cipher = cipher;
const decipher = (salt) => {
    const textToChars = (text) => text.split('').map(c => c.charCodeAt(0));
    const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
    return (encoded) => (encoded.match(/.{1,2}/g) || [])
        .map(hex => parseInt(hex, 16))
        .map(applySaltToChar)
        .map(charCode => String.fromCharCode(charCode))
        .join('');
};
exports.decipher = decipher;
